import React, { useContext, useEffect, useState } from 'react';
import { AB_TEST_RUNNING_MESSAGE, APPLETS, SELECT_APPLET } from '../../utils/Constants';
import { getLiveApplets, getAllApplets } from '../../services/ABServices';
import { AppContext } from 'Context/AppContext';
import { TAppletInfo, TAppletResponse, TPayload, TUpdateTest } from '../../types/ab';
import { ABContext } from '../../contexts/ABContext';
import { toast } from 'react-toastify';

const AppletsSection = () => {
    const appContext = useContext(AppContext);
    const { setDefaultModels, setModels, appletInfo, setAppletInfo, setSelectedApplet, setUpdateTest, selectedApplet, setPayload, liveApplets, setLiveApplets } = useContext(ABContext);
    const [applets, setApplets] = useState<TAppletResponse[]>([]);

    useEffect(() => {
        if (appContext?.channelKey) {
            getApplets();
        }
    }, [appContext?.channelKey]);

    useEffect(() => {
        appendApplet(appletInfo);
    }, [appletInfo]);

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = e.target.value;
        const selectedApplet = applets.find(applet => applet.applet_id === selectedId);
        if (liveApplets?.length === 0) fetchLiveApplets()
        if (selectedApplet) {
            const { applet_id, applet_name, applet } = selectedApplet;
            setAppletInfo((prev: TAppletInfo) => ({
                ...prev,
                applet: applet,
                applet_name: applet_name,
                applet_id: applet_id,
            }))
            setPayload((prevPayload: TPayload) => {

                const updatedPayload = {
                    ...prevPayload, applets: [{
                        applet: applet,
                        applet_name: applet_name,
                        applet_id: applet_id,
                    }]
                };
                return updatedPayload;
            });
            checkAppletInUse(selectedId)
        } else { setModels([]) }
        setSelectedApplet(selectedId);
    };

    const fetchLiveApplets = async () => {
        if (!appContext?.channelKey) return
        try {
            const liveAppletsResponse = await getLiveApplets(appContext?.channelKey)
            setLiveApplets(liveAppletsResponse?.data?.ab_test_applet || []);
            setDefaultModels(liveAppletsResponse?.data?.default_models || {})
            return liveAppletsResponse?.data?.ab_test_applet;
        } catch (error) {
            setLiveApplets([]);
            setDefaultModels({});
            toast.error('Failed to fetch live applets');
        }
    }

    const checkAppletInUse = async (appletId: string) => {
        let appletList = liveApplets;
        if (!appletList?.length) {
            const freshAppletList = await fetchLiveApplets();
            if (freshAppletList?.length) {
                appletList = freshAppletList;
            }
        }

        if (appletList?.length > 0 && appletList?.includes(appletId)) {
            toast.warning(AB_TEST_RUNNING_MESSAGE);
        }
    };

    const getApplets = async () => {
        try {
            if (!appContext?.channelKey) return
            const response = await getAllApplets(appContext?.channelKey ?? '');
            if (response?.done) {
                setApplets(response?.data ?? []);
            }
        } catch (error) {
            console.log("getApplets ~ error:", error)
        }
    }

    const appendApplet = (newApplet: TAppletInfo) => {
        setUpdateTest((prevUpdateTest: TUpdateTest) => ({
            ...prevUpdateTest,
            applets: [...prevUpdateTest.applets, newApplet],
        }));
    };

    return (
        <div className='tw-my-3 tw-pb-6 tw-border-b'>
            <div className="tw-w-[20%]">
                <label className="text-caption-style tw-text-[#747593]">{APPLETS}</label>
                <select className="shadow-none form-select drop-down-dm tw-ps-3" title={APPLETS} id="applet" aria-label={APPLETS} value={selectedApplet || ''} onChange={handleSelectChange}>
                    <option value="">{SELECT_APPLET}</option>
                    {applets.map(applet => (
                        <option key={applet.applet_id} value={applet.applet_id}>
                            {applet.applet_name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default AppletsSection;